var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGitlabLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 70,
    fillRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 61.477L43.784 25.2H20.216z",
    fill: "#e24329"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 61.477L20.216 25.2H3.7z",
    fill: "#fc6d26"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7 25.2L.12 36.23a2.44 2.44 0 0 0 .886 2.728L32 61.477z",
    fill: "#fca326"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7 25.2h16.515L13.118 3.366c-.365-1.124-1.955-1.124-2.32 0z",
    fill: "#e24329"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32 61.477L43.784 25.2H60.3z",
    fill: "#fc6d26"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3 25.2l3.58 11.02a2.44 2.44 0 0 1-.886 2.728L32 61.477z",
    fill: "#fca326"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3 25.2H43.784l7.098-21.844c.365-1.124 1.955-1.124 2.32 0z",
    fill: "#e24329"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitlabLogo);
export default __webpack_public_path__ + "static/media/gitlab-logo.463510ab.svg";
export { ForwardRef as ReactComponent };